import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "team-table-backoffice"
}
const _hoisted_2 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = { class: "avatar avatar-circle" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  class: "avatar-img",
  src: "https://htmlstream.com/preview/front-v4.3.1/assets/img/160x160/img1.jpg"
}
const _hoisted_7 = { class: "flex-grow-1 ms-3 mb-0" }
const _hoisted_8 = { class: "mb-0" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { class: "text-lowercase" }
const _hoisted_12 = { class: "justify-content-end d-flex" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-pencil-square" }, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-trash" }, null, -1)
const _hoisted_15 = { class: "pt-4 pb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DeleteEntityModal = _resolveComponent("DeleteEntityModal")!
  const _component_MrUiKitButton = _resolveComponent("MrUiKitButton")!
  const _component_MrUiKitTable = _resolveComponent("MrUiKitTable")!
  const _component_MrUiKitPagination = _resolveComponent("MrUiKitPagination")!

  return (_ctx.entityId != -1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.showDeleteModal === true && _ctx.selectedResult)
          ? (_openBlock(), _createBlock(_component_DeleteEntityModal, {
              key: 0,
              name: _ctx.selectedResult.competition.name,
              onSubmit: _ctx.onSubmitDelete,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDeleteModal = false))
            }, null, 8, ["name", "onSubmit"]))
          : _createCommentVNode("", true),
        _createVNode(_component_MrUiKitTable, {
          rows: _ctx.rows,
          columns: _ctx.columns
        }, {
          name: _withCtx(({item}) => [
            (_ctx.type === 'team')
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      (item.photo)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "avatar-img",
                            src: item.photo.url
                          }, null, 8, _hoisted_5))
                        : (_openBlock(), _createElementBlock("img", _hoisted_6))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("h5", _hoisted_8, _toDisplayString(item.competition.name ?? item.competition), 1)
                  ])
                ]))
              : (_ctx.type === 'single')
                ? (_openBlock(), _createElementBlock("h5", _hoisted_9, _toDisplayString(item.competition), 1))
                : _createCommentVNode("", true)
          ]),
          results: _withCtx(({item}) => [
            (item.position != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createTextVNode(_toDisplayString(item.position) + "º ", 1),
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t('result.position')), 1)
                ]))
              : _createCommentVNode("", true)
          ]),
          action: _withCtx(({item}) => [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_MrUiKitButton, {
                classes: ['btn-icon btn-primary-outline btn-sm'],
                onClick: ($event: any) => (_ctx.onUpdate(item))
              }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 2
              }, 1032, ["onClick"]),
              _createVNode(_component_MrUiKitButton, {
                classes: ['btn-icon btn-primary-outline btn-sm'],
                onClick: ($event: any) => (_ctx.onDelete(item))
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 2
              }, 1032, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["rows", "columns"]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_MrUiKitPagination, {
            modelValue: _ctx.pagination,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.pagination) = $event)),
            onLoad: _ctx.loadMore
          }, {
            default: _withCtx((slotProps) => [
              _createTextVNode(_toDisplayString(_ctx.t('pagination.page')) + " " + _toDisplayString(_ctx.pagination.current) + " " + _toDisplayString(_ctx.t('pagination.of')) + " " + _toDisplayString(slotProps.lastPage), 1)
            ]),
            _: 1
          }, 8, ["modelValue", "onLoad"])
        ])
      ]))
    : _createCommentVNode("", true)
}